import { useNavigate } from "react-router-dom";
import BossBottomTab from "../components/boss-bottom-tab";
import { useAuth } from "../../../core/auth";
import { track } from "@amplitude/analytics-browser";
import { FaBell, FaBullhorn, FaUser, FaBan, FaEnvelope } from "react-icons/fa";
import { FcCustomerSupport } from "react-icons/fc";
import { IoStorefront } from "react-icons/io5";
import { FaKey } from "react-icons/fa6";
import { HiMiniCurrencyDollar } from "react-icons/hi2";
import { GoStar } from "react-icons/go";
import { FaExchangeAlt } from "react-icons/fa";
import { HiChartBar } from "react-icons/hi";
import { useQuery } from "@apollo/client";
import { GET_SELLER_STORE } from "../api/seller-store";
import StoreTitle from "../components/store-title";

const BossMy = () => {
  const navigate = useNavigate();
  const { logoutAdmin, changeLastPage, isManagerLoggedIn } = useAuth();
  const { data: storeData } = useQuery(GET_SELLER_STORE, {
    fetchPolicy: "cache-and-network",
  });

  const handleLogout = () => {
    logoutAdmin();
    changeLastPage();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#f4f5f7] flex flex-col pb-[92px]">
      <StoreTitle title={storeData?.getSellerStore?.title} />
      <div className="p-6 flex flex-col items-center">
        <h2 className="text-4xl font-bold text-center mb-3 text-gray-800">
          마이페이지
        </h2>
        {/* 의견/건의사항 - 상단 우체통 가로 나열 */}
        <button
          onClick={() => navigate("/boss/feedback")}
          className="w-[230px] bg-white text-[#1562fc] rounded-lg shadow-md hover:bg-blue-50 transition-colors flex items-center justify-center gap-2 py-3 px-4 mb-6"
        >
          <FaEnvelope className="w-5 h-5 text-blue-400 shrink-0" />
          <span className="text-base font-semibold">의견/건의사항</span>
        </button>
        <div className="w-full max-w-md">
          <section className="grid grid-cols-2 gap-6 w-full max-w-md">
            {/* 매장관리 */}
            <button
              onClick={() => navigate("/boss/my/store-management")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <IoStorefront className="w-10 h-10 text-[#1562fc]" />
              <span className="text-lg text-gray-800 font-semibold">
                매장관리
              </span>
            </button>

            {/* 내정보 */}
            <button
              onClick={() => navigate("/boss/my/profile")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FaKey className="w-10 h-10 text-yellow-400" />
              <span className="text-lg text-gray-800 font-semibold">
                로그인 정보
              </span>
            </button>

            {/* 매출정보 */}
            <button
              onClick={() => navigate("/boss/my/revenue")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <HiChartBar className="w-10 h-10 text-red-500" />
              <span className="text-lg text-gray-800 font-semibold">
                우리가게 매출
              </span>
            </button>

            {/* 정산정보 */}
            <button
              onClick={() => navigate("/boss/my/banking/settlement")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <HiMiniCurrencyDollar className="w-10 h-10 text-green-700" />
              <span className="text-lg text-gray-800 font-semibold">
                정산센터
              </span>
            </button>

            {/* 고객센터 */}
            <button
              onClick={() => navigate("/boss/my/support")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FcCustomerSupport className="w-10 h-10 text-blue-400" />
              <span className="text-lg text-gray-800 font-semibold">
                고객센터
              </span>
            </button>

            <button
              onClick={() => navigate("/boss/my/notification")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FaBell className="w-10 h-10 text-yellow-500" />

              <span className="text-lg text-gray-800 font-semibold">
                알림 설정
              </span>
            </button>

            <button
              onClick={() => {
                track("사장님 내 매장 리뷰 보기 클릭");
                navigate("/boss/review");
              }}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <GoStar className="w-10 h-10 text-yellow-300" />
              <span className="text-lg text-gray-800 font-semibold">
                매장 리뷰
              </span>
            </button>

            {/* 차단 관리 */}
            <button
              onClick={() => navigate("/boss/my/blacklist")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FaBan className="w-10 h-10 text-red-500" />
              <span className="text-lg text-gray-800 font-semibold">
                차단 관리
              </span>
            </button>

            {/* 내정보 */}
            <button
              onClick={() => handleLogout()}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FaExchangeAlt className="w-10 h-10 text-black" />
              <span className="text-lg text-gray-800 font-semibold">
                소비자 앱 전환 <br />
                (내 매장 보러가기)
              </span>
            </button>

            {/* 공지사항 */}
            <button
              onClick={() => navigate("/boss/my/notice")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FaBullhorn className="w-10 h-10 text-blue-600" />
              <span className="text-lg text-gray-800 font-semibold">
                공지사항
              </span>
            </button>

            <button
              onClick={() => {
                if (isManagerLoggedIn) {
                  navigate("/manager/home");
                } else {
                  navigate("/manager/login");
                }
              }}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FaUser className="w-10 h-10 text-blue-600" />
              <span className="text-lg text-gray-800 font-semibold">
                {isManagerLoggedIn ? "가게 전환" : "매니저 로그인"}
              </span>
            </button>
          </section>
        </div>
      </div>
      <BossBottomTab />
    </div>
  );
};

export default BossMy;
